<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">Member Data</div>
        <div class="box-mini">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-3">
                <table>
                  <tr>
                    <td>
                      <a @click="exportBooking()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                    </td>
                    <td>
                      <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates" name="export_date_start" class="font-13"></flat-pickr>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="col-sm-3">
                <b-form-select v-if="getRoleMappingId.includes(17) || getRoleMappingId.includes(22) || getRoleMappingId.includes(4)" name="memberData" class="w-auto" @change="changeMemberData" v-model="valueMemberData">
                  <option :value="null">Please select</option>
                  <option :value="1">All Member</option>
                  <option :value="2">My Member</option>
                </b-form-select>
              </div>
              <div class="col-sm-3">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Branch
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="branch" v-model="branch_id" @change="changeBranch" :disabled="!isAdmin">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <!-- {{items}} -->
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" :responsive="true" :items="items" :fields="fields">
              <template v-slot:cell(name)="data">
                {{data.item.first_name}} {{data.item.last_name}}
              </template>
              <template v-slot:cell(owner)="data">
                {{ data.item.sales ? data.item.sales.fullname : '' }}
              </template>
              <template v-slot:cell(is_agree)="data">
                <template>
                  <b-badge v-if="data.item.is_agree == 1" :variant="'success'" >Success</b-badge>
                  <b-badge v-if="data.item.is_agree == 0"  :variant="'warning'" >Waiting...</b-badge>
                </template>
              </template>
              <template v-slot:cell(membershipStatus)="data">
                <b-badge :variant="statusMembership(data.item.membership_status.name)" v-if="data.item.membership_status">{{data.item.membership_status.name}}</b-badge>
              </template>
              <template v-slot:cell(actions)="data">
                <template v-if="data.item.lead">
                  <b-button size="sm" @click="openPage('/memberData/detail?id=' + data.item.id + '&id_lead=' + data.item.lead.id)" class="btn-table green mr-1">
                    <i class="far fa-eye"></i> Detail
                  </b-button>
                </template>
                <template v-else>
                  <b-button size="sm" @click="openPage('/memberData/detail?id=' + data.item.id)" class="btn-table green mr-1">
                    <i class="far fa-eye"></i> Detail
                  </b-button>
                </template>
              </template>
            </b-table>
            <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="40" alt="">
        <br>
        <div class="title-loading color-white">Please wait...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'leads',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'name',
          label: 'Member Name',
          sortable: true
        },
        {
          key: 'age',
          label: 'Usia',
          formatter: (value, key, item) => {
            return item.birthday ? moment().diff(moment(item.birthday), 'years') + ' Tahun' : '-'
          },
          sortable: false
        },
        {
          key: 'branch.name',
          label: 'Branch',
          sortable: false
        },
        {
          key: 'owner',
          label: 'Lead Owner',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: false
        },
        // {
        //   key: 'email',
        //   label: 'Email',
        //   sortable: true
        // },
        {
          key: 'membership_last_buy_name',
          label: 'Membership Type',
          sortable: true
        },
        {
          key: 'start_membership',
          label: 'Join Date',
          class: (Auth.Session.get().paradigm_role == 7 || Auth.Session.get().paradigm_role == 9) ? 'hidden' : '',
          formatter: (value, key, item) => {
            return (item.start_membership ? moment(item.start_membership).format('DD MMMM YYYY') : '-')
          },
          sortable: true
        },
        {
          key: 'membership_expired_date',
          label: 'Expired Date',
          class: (Auth.Session.get().paradigm_role == 7 || Auth.Session.get().paradigm_role == 9) ? 'hidden' : '',
          formatter: (value, key, item) => {
            return (item.membership_expired_date ? moment(item.membership_expired_date).format('DD MMMM YYYY') : '-')
          },
          sortable: false
        },
        {
          key: 'session_qty',
          label: 'PT Session',
          class: (Auth.Session.get().paradigm_role == 7 || Auth.Session.get().paradigm_role == 9) ? '' : 'hidden',
          formatter: (value, key, item) => {
            return (item.member_pt_sessions && item.member_pt_sessions[0] ? item.member_pt_sessions[0].current_session_qty + ' of ' + item.member_pt_sessions[0].buy_session_qty : '-')
          },
          sortable: false
        },
        {
          key: 'session_expired',
          label: 'PT Session Expired',
          class: (Auth.Session.get().paradigm_role == 7 || Auth.Session.get().paradigm_role == 9) ? '' : 'hidden',
          formatter: (value, key, item) => {
            return (item.member_pt_sessions && item.member_pt_sessions[0] ? moment(item.member_pt_sessions[0].expired_at).format('DD MMMM YYYY') : '-')
          },
          sortable: false
        },
        {
          key: 'is_agree',
          label: 'Agreement',
          sortable: true
        },
        {
          key: 'membershipStatus',
          label: 'Membership Status',
          sortable: false
        },
        {
          key: 'class_last_check_in',
          label: 'Last Check In',
          sortable: false
        },
        {
          key: 'point_expired_date',
          label: 'Point Expired',
          sortable: false
        },
        {
          key: 'total_point',
          label: 'Total Point',
          formatter: (value) => {
            return 'Rp. '+value
          },
          sortable: false
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      // Filter branch mengikuti branch login, kecuali admin (superadmin) yang bebas memilih.
      isAdmin: Auth.Session.get().paradigm_role == 1,
      branch_id: null,
      dataBranch: [],
      valueMemberData: null,
      getParadigmRole: '',
      getRoleMappingId: Auth.Session.get().paradigm_role_mapping_id,
      dateWeek: '',
      itemSales: [],
      items: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      changeMemberValue: '',
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
    }
  },
  methods: {
    changeBranch(event) {
      this.fetchData()
    },
    branchParam () {
      return this.branch_id ? '&branch_id=' + this.branch_id : ''
    },
    // export
    exportBooking() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      // '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData
      let url = 'crm/v1/export/member_data/1071806?page=&limit=&sorting=&sorting_type=&keyword=&start_date='+dates[0]
        +'&end_date='+dates[1]
        + this.branchParam()
        +' ';

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Member_Data-'+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
        this.loadingActive = false
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    changeDateBooking(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    changeMemberData (event) {
      this.changeMemberValue = event
      let dates = this.exportDates.split(' to ')
      if(event == 2) {
        axios.get('fitness/v1/personal_training/member_data?pt_id=' + Auth.Session.get().paradigm_id + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + this.branchParam()).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
        }).catch(error => {
          console.log('error', error)
        })
      } else {
        axios.get('crm/v1/sales/my_convert/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +
        '&start_date=' + dates[0] + '&end_date=' + dates[1] + this.branchParam()).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      let dates = this.exportDates.split(' to ')
      if(this.changeMemberValue == 1) {
        axios.get('crm/v1/sales/my_convert/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +
        '&start_date=' + dates[0] + '&end_date=' + dates[1] + this.branchParam()).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
      } else if(this.changeMemberValue == 2) {
        axios.get('fitness/v1/personal_training/member_data?pt_id=' + Auth.Session.get().paradigm_id + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + this.branchParam()).then(response => {
          // console.log('response', response.data.data.rows)
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
      } else {
        this.fetchData()
      }
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      let dates = this.exportDates.split(' to ')
      if(this.changeMemberValue == 1) {
        axios.get('crm/v1/sales/my_convert/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +
        '&start_date=' + dates[0] + '&end_date=' + dates[1] + this.branchParam()).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
      } else if(this.changeMemberValue == 2) {
        axios.get('fitness/v1/personal_training/member_data?pt_id=' + Auth.Session.get().paradigm_id + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + this.branchParam()).then(response => {
          // console.log('response', response.data.data.rows)
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
      } else {
        this.fetchData()
      }
    },
    enterClicked (searchEvent) {
      console.log(this.changeMemberValue)
      if(this.changeMemberValue == 1) {
        axios.get('crm/v1/sales/my_convert/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + this.branchParam()).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
      } else if(this.changeMemberValue == 2) {
        axios.get('fitness/v1/personal_training/member_data?pt_id=' + Auth.Session.get().paradigm_id + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + this.branchParam()).then(response => {
          // console.log('response', response.data.data.rows)
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
      } else {
        axios.get('crm/v1/sales/my_convert/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + this.branchParam()).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', response.data)
        }).catch(error => {
          console.log('error', error)
        })
      }
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      return (status === 'Active') ? 'success'
          : (status === 'Terminated') ? 'danger'
          : (status === 'Canceled') ? 'danger'
          : (status === 'Outstanding') ? 'danger' : 'warning'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    fetchData() {
      console.log(Auth.Session.get().paradigm_role)
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')

      // branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/sales/').then(response => {
        this.itemSales = response.data.data.rows
        // console.log('error', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      if(Auth.Session.get().paradigm_role === '6' || Auth.Session.get().paradigm_role === '8' || Auth.Session.get().paradigm_role === '19' || Auth.Session.get().paradigm_role === '20' || Auth.Session.get().paradigm_role === '34' || Auth.Session.get().paradigm_role === '35') {
        axios.get('crm/v1/sales/my_convert/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +
        '&start_date=' + dates[0] + '&end_date=' + dates[1] + '&branch_id=' + this.branch_id).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else if(Auth.Session.get().paradigm_role === '7' || Auth.Session.get().paradigm_role === '9' || Auth.Session.get().paradigm_role === '18') {
        axios.get('fitness/v1/personal_training/member_data?pt_id=' + Auth.Session.get().paradigm_id + '&page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else {
        axios.get('crm/v1/sales/my_convert/' + Auth.Session.get().paradigm_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +
        '&start_date=' + dates[0] +'&end_date=' + dates[1] + '&branch_id=' + this.branch_id).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      }
    }
  },
  // mounted (){
  //   axios.get('crm/v1/sales/').then(response => {
  //     this.itemSales = response.data.data.rows
  //     // console.log('error', response.data.data.rows)
  //   }).catch(error => {
  //     console.log('error', error)
  //   })
  // },
  created () {
    this.getParadigmRole = Auth.Session.get().paradigm_role
    if (!this.isAdmin && Number(Auth.Session.get().paradigm_branch_id)) {
      this.branch_id = Number(Auth.Session.get().paradigm_branch_id)
    }
    if(Auth.Session.get().paradigm_role === '7' || Auth.Session.get().paradigm_role === '9') {
      this.valueMemberData = 2
    }
    this.fetchData()
  }
}
</script>
